import { UniFiChildCategorySlug } from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/wall/u6-in-wall.png";
import type { Product } from "../../types";
import { wifiWall } from "../product-list-groups/wifiWall";
import {
  connectedDevices,
  customization,
  dimensions,
  integratedSwitch,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";

export const u6InWall: Product = {
  id: "u6InWall",
  productTitle: "U6 In-Wall",
  techspecsPath: [SiteId.TechSpecs, "/unifi/wifi/u6-iw"],
  storePathParts: {
    productSlug: "u6-iw",
    category: UniFiChildCategorySlug.WiFiWall,
  },
  sku: "U6-IW",
  description: "u6InWall.description",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiWall,
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u6InWall.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u6InWall.dimensions",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "115 m² (1,250 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "300+" },
    },
    {
      propertyId: integratedSwitch.id,
      value: {
        type: "translation",
        value: "u6InWall.integratedSwitch",
      },
    },
    {
      propertyId: "powerMethodPoe",
      value: {
        type: "string",
        value: "PoE / PoE+",
        asterisk: 1,
      },
    },
    {
      propertyId: uplink.id,
      value: { type: "translation", value: "u6InWall.uplink" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "u6InWall.mounting",
      },
    },
    {
      propertyId: customization.id,
      value: { type: "boolean", value: false },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["u6InWall.notes"],
};
